










































































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import PemantauanAnestesiSvc from "@/services/PemantauanAnestesiService";
import { appModule } from "@/store/modules/app";
import PemantauanAnestesiFinalisasi from "./PemantauanAnestesiFinalisasi.vue";
import PemantauanAnestesiGrafik from "./PemantauanAnestesiGrafik.vue";
import PemantauanAnestesiIdentitas from "./PemantauanAnestesiIdentitas.vue";
import PemantauanAnestesiObatCairan from "./PemantauanAnestesiObatCairan.vue";
import PemantauanAnestesiPraInduksi from "./PemantauanAnestesiPraInduksi.vue";
import PemantauanAnestesiTeknik from "./PemantauanAnestesiTeknik.vue";

@Component({
  components: {
    PemantauanAnestesiIdentitas,
    PemantauanAnestesiPraInduksi,
    PemantauanAnestesiTeknik,
    PemantauanAnestesiGrafik,
    PemantauanAnestesiObatCairan,
    PemantauanAnestesiFinalisasi
  }
})
export default class PemantauanAnestesiStepper extends Vue {
  @Prop() register!: string;
  @Prop() rm!: string;
  @Prop({ default: null }) editData!: any;
  @Prop({ default: false }) readonly!: boolean;

  currentStep = 1;
  currentData: any = null;
  saving = false;

  stepRefNames = [
    { ref: "stepIdentitas", step: 1 },
    { ref: "stepPraInduksi", step: 2 },
    { ref: "stepTeknik", step: 3 },
    { ref: "stepObatCairan", step: 5 },
    { ref: "stepFinalisasi", step: 6 }
  ];

  //  created() not mounted() — child mounted() runs before parent's,
  // so currentData must be set here or Identitas prefills from a null editData
  created() {
    if (this.editData) {
      this.currentData = { ...this.editData };
      this.setInitialStep();
      this.refreshData(); // list item lacks relations (ttvs/obats); pull full record so grafik shows
    }
  }

  @Watch("editData")
  onEditDataChanged(val: any) {
    if (val) {
      this.currentData = { ...val };
      this.setInitialStep();
      this.refreshData(); // list item lacks relations (ttvs/obats); pull full record so grafik shows
    }
  }

  setInitialStep() {
    if (!this.currentData) return;
    if (this.currentData.akhir_anestesi_at) {
      this.currentStep = 6;
    } else if (this.currentData.mulai_anestesi_at) {
      this.currentStep = 4;
    } else if (this.currentData.id) {
      this.currentStep = 2;
    } else {
      this.currentStep = 1;
    }
  }

  get asaColor() {
    if (!this.currentData) return "grey";
    const asa = this.currentData.asa_status;
    if (["3", "4", "5", "6", "E"].includes(asa)) return "red";
    if (asa === "2") return "orange";
    return "green";
  }

  get step1Complete() {
    return !!this.currentData;
  }

  get step2Complete() {
    return !!this.currentData && !!this.currentData.pra_induksi_td_sistolik;
  }

  get step3Complete() {
    return !!this.currentData && !!this.currentData.mulai_anestesi_at;
  }

  get step4Complete() {
    return (
      !!this.currentData &&
      this.currentData.ttvs &&
      this.currentData.ttvs.length > 0
    );
  }

  get step5Complete() {
    return (
      !!this.currentData &&
      (this.currentData.total_obat_entries > 0 || this.currentData.cairan_masuk)
    );
  }

  get step6Complete() {
    return !!this.currentData && !!this.currentData.is_locked;
  }

  async refreshData() {
    if (!this.currentData?.id) return;
    try {
      const resp = await PemantauanAnestesiSvc.find(this.currentData.id);
      if (resp.data.status == "1") {
        this.currentData = resp.data.data;
      }
    } catch {
      // handled by service
    }
  }


  mountedSteps() {
    return this.stepRefNames
      .map(s => ({ ...s, cmp: this.$refs[s.ref] as any }))
      .filter(s => !!s.cmp);
  }

  buildPayload() {
    const payload: any = {};
    this.mountedSteps().forEach(s => {
      const part = s.cmp.collectPayload() || {};
      const dirty = s.cmp.isDirty ? s.cmp.isDirty() : true;
      Object.keys(part).forEach(key => {
        if (dirty || payload[key] === undefined) {
          payload[key] = part[key];
        }
      });
    });
    return payload;
  }

  async simpanSemua() {
    const steps = this.mountedSteps();
    const invalid = steps.find(s => !s.cmp.validateStep());
    if (invalid) {
      this.currentStep = invalid.step;
      appModule.sendErrorAlert("Ada isian wajib yang belum lengkap");
      return;
    }

    this.saving = true;
    try {
      const payload = this.buildPayload();
      const isNew = !this.currentData?.id;
      const resp = isNew
        ? await PemantauanAnestesiSvc.create(payload)
        : await PemantauanAnestesiSvc.update(this.currentData.id, payload);

      if (resp?.data?.status == "1") {
        appModule.NoticeDelay("Berhasil menyimpan");
        steps.forEach(s => {
          if (s.cmp.markSaved) s.cmp.markSaved();
        });
        this.currentData = resp.data.data;
        if (isNew) {
          this.currentStep = 2;
        }
      }
    } catch {
      // 
    }
    this.saving = false;
  }

  onSelesai() {
    this.$emit("saved");
  }
}
